import router from '@/router/index';
import { Message } from 'element-gui';
import service from '@/request/service';
import toolbar from './toolbar';
import * as types from '../mutation-types';

const state = {
  userInfo: {},
  currentServerDateTime: 0,
  activeNames: [],
  projectList: [],
  currentBidSection: {},
  onlineUserCount: '',
  currentBidSectionList: [],
  obj: [],
  role: {
    roleKey: '',
  },
};
const getters = {
  getMenu: (state) => state.obj,
  userName: (state) => state.userInfo.userName || '',
  formatTime: (state) => {
    const currentServerDateTime = new Date(Number(state.currentServerDateTime));
    let year = currentServerDateTime.getFullYear();
    let month = currentServerDateTime.getMonth() + 1;
    let date = currentServerDateTime.getDate();
    month = month < 10 ? `0${month}` : month;
    date = date < 10 ? `0${date}` : date;

    return `${year}-${month}-${date}`;
  },
};
const actions = {
  async setRoleKey({ commit }, obj) {
    commit('GETROLESTATUS', obj);
  },
  // 退出
  handleLogOut() {
    service({
      url: '/user/logout',
      method: 'post',
    }).then((response) => {
      console.log(response);
      if (response.code == 200) {
        window.sessionStorage.clear();
        router.push({ path: '/login' });
      } else {
        Message({
          message: response.msg,
          type: 'error',
        });
      }
    });
  },

  // 获取服务器时间
  getServerTime({ commit }) {
    service
      .get('/tools/getCurrentServerDate')
      .then(({ data, code, errorMsg }) => {
        if (code !== 200) {
          Message({
            message: errorMsg,
            type: 'error',
          });
          return;
        }
        const timeStamp = data.timeStamp;
        commit('CURRENTDATETIME', timeStamp);
      });
  },
  //当天开标的项目列表
  getProjectList({ state, commit, dispatch }) {
    commit('CURRENTBIDSECTIONLIST', []);
    service
      .post('/projectlist/today/list', {
        roleType: state.userInfo.userType,
        userCode: state.userInfo.userId,
      })
      .then(({ data, code, errorMsg }) => {
        if (code != 200) {
          Message({
            message: errorMsg,
            type: 'error',
          });
        } else {
          const { list } = data || [];
          if (!list.length) {
            commit('PROJECTLIST', list);
            commit('CURRENTBIDSECTION', {});
            commit('ACTIVENAMES', []);
            return;
          }
          let row;
          if (Object.keys(state.currentBidSection).length > 0) {
            row = state.currentBidSection
          } else {
            row = list[0] && list[0].sectionList[0];
          }
          const { bidSectionId, unionSection, domainId } = row;
          list.forEach((item) => {
            const sectionList = item.sectionList || [];
            sectionList.forEach((ite, index) => {
              sectionList[index] = { ...ite, isChecked: false };

              if (ite.bidSectionId === bidSectionId) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }
              if (
                unionSection &&
                ite.domainId === domainId &&
                ite.bidSectionId !== bidSectionId
              ) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }
            });
          });

          const activeNames = list.map((item) => item.projectId);

          commit('ACTIVENAMES', activeNames);
          commit('PROJECTLIST', list);
          commit('CURRENTBIDSECTION', row);
        }
      });
  },
  // 更新列表
  updateProjectList({ state, dispatch, commit }) {
    commit('CURRENTBIDSECTIONLIST', []);
    service
      .post('/projectlist/today/list', {
        roleType: state.userInfo.userType,
        userCode: state.userInfo.userId,
      })
      .then(({ data, code, errorMsg }) => {
        if (code !== 200) {
          Message({
            message: errorMsg,
            type: 'error',
          });
        } else {
          const { list } = data || [];
          if (!list.length) return;
          const row = state.currentBidSection;
          const { bidSectionId, unionSection, domainId } = row;
          list.forEach((item) => {
            const sectionList = item.sectionList || [];
            sectionList.forEach((ite, index) => {
              sectionList[index] = { ...ite, isChecked: false };

              if (ite.bidSectionId === bidSectionId) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }

              if (
                unionSection &&
                ite.domainId === domainId &&
                ite.bidSectionId !== bidSectionId
              ) {
                sectionList[index] = { ...ite, isChecked: true };
                commit('CURRENTBIDSECTIONLIST', [
                  ...state.currentBidSectionList,
                  ite,
                ]);
              }
            });
          });
          commit('PROJECTLIST', list);
          /*const openTime = +new Date(
              state.currentBidSection.openTime.replace(/-/g, '/')
          );
          if (
            row.openState === 0 &&
            openTime - state.currentServerDateTime <= 0
          ) {}*/
          if (
              row.openState === 0
          ) {
            dispatch('handleOver');
          }
        }
      });
  },
  // 倒计时结束
  handleOver({ dispatch }) {
    service.post('/openBid/info/update/opening').then(({ code, errorMsg }) => {
      if (code !== 200) {
        Message({
          message: errorMsg,
          type: 'error',
        });
        return;
      }
      dispatch('getProjectList');
    });
  },

  // 获取在线用户
  handleOnlineBidderList({ state, commit }) {
    service
      .get('/bidder/getOnlineUserCounts', {
        params: {
          domainId: state.currentBidSection.domainId,
        },
      })
      .then((data) => {
        commit('ONLINEUSERCOUNT', data.data || 0);
      });
  },

  handleOpenBid({ state, dispatch }) {
    const list = state.currentBidSectionList;
    service
      .get('/prepare/getBidderId/' + state.currentBidSection.bidSectionId, {
        params: { bidSectionId: state.currentBidSection.bidSectionId },
      })
      .then((r) => {
        if (r.code === 200) {
          dispatch(
            'toolbar/getTendCtrlPriceInfo',
            { visible: false },
            { root: true }
          );
          // 整个domainList复制bidderId
          list.forEach((item) => {
            if (r.data && r.data.split('_').length > 2) {
              item['bidderId'] = r.data.split('_')[0];
              item['bidderName'] = r.data.split('_')[1];
              item['invalidStatus'] = r.data.split('_')[2];
            } else {
              item['bidderId'] = '';
              item['bidderName'] = '';
              item['invalidStatus'] = '1';
            }
          });
          sessionStorage.setItem('row', JSON.stringify(list));
          let excluUrl = [];
          if (sessionStorage.getItem('roleKey') == '2') {
            excluUrl = ['/index/bidOpen'];
            if (state.currentBidSection.region == '山西') {
              excluUrl = ['/index/bidOpen', '/index/pubBidder'];
            }
          }
          service
            .post('/project/openReady/getJumpUrl', {
              bidSectionId: state.currentBidSection.bidSectionId,
              excludUrl: excluUrl,
            })
            .then((data) => {
              if (data.code === 200) {
                dispatch('getMenuStatus', {
                  bidSectionId: state.currentBidSection.bidSectionId,
                  data: data.data,
                });
              } else {
                Message({
                  message: data.msg,
                  type: 'error',
                });
              }
            });
        }
      });
  },
  // 无阶段导航
  getMenuStatus({ commit }, obj) {
    service
      .get('/project/openReady/getMenuList', {
        params: { bidSectionId: obj.bidSectionId },
      })
      .then((res) => {
        if (res.code === 200) {
          if (res.data.list.length) {
            // 投标人不需要开标准备
            console.log("44444444444444444", res.data.list[0].menus)
            if (window.sessionStorage.getItem('roleKey') == '2') {
              if (res.data.list[0].menus[0].type === '开标准备') {
                res.data.list[0].menus.shift();
              }
              // JSON.parse(window.sessionStorage.getItem('row'))[0].region ==='山西'
              if (
                ['山西','福建','新疆','浙江','全国'].includes(JSON.parse(window.sessionStorage.getItem('row'))[0].region)
              ) {
                res.data.list[0].menus.forEach(function (item, index) {
                  if (item.type === '公布投标人名单') {
                    // res.data.list[0].menus.splice(index, 1);
                    sessionStorage.setItem('menuName', item.menuName);
                  }
                });
              }
            }
            console.log('+++++++******')
            // 重构数据 单阶段
            if (res.data.list.length === 1) {
            //   let obj1 = {
            //   icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '特征码一览表',
            //   path: "/index/signatureList",
            //   status: 0,
            //   type: "特征码一览表",
            //   url: "/index/signatureList",
            // };
            // let obj2 = {
            //   icon: "finalists",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '入围名单', 
            //   path: "/index/finalists",
            //   status: 0,
            //   type: "入围名单",
            //   url: "/index/finalists",
            // }
            //   res.data.list[0].menus.splice(-1, 0, obj1, obj2)
              
            // if (window.sessionStorage.getItem('roleKey') == '2') { 
            //   res.data.list[0].menus.forEach(function (item, index) {
            //     if (item.type === '特征码一览表') {
                  
            //       res.data.list[0].menus.splice(index, 1);
            //     }
            //   });
            // } 

            // 投标单位入围  和 随机赋码
            // let obj1 = {
            //   icon: "signatureList",
            //   index: 7,
            //   isLeaf: true,
            //   menuName: '投标单位入围',
            //   path: "/index/openbidderEnter",
            //   status: 0,
            //   type: "投标单位入围",
            //   url: "/index/openbidderEnter",
            // };
            // let obj2 = {
            //   icon: "signatureList",
            //   index: 8,
            //   isLeaf: true,
            //   menuName: '随机赋码', 
            //   path: "/index/bidderRandomCode",
            //   status: 0,
            //   type: "随机赋码",
            //   url: "/index/bidderRandomCode",
            // }
            // res.data.list[0].menus.splice(4, 0, obj1, obj2)

            if (JSON.parse(window.sessionStorage.getItem('obj')).userType == '2' ) { 
                res.data.list[0].menus.forEach(function (item, index) {
                  if (item.type === '随机抽球法-投标单位入围') {
                    res.data.list[0].menus.splice(index, 1);
                  }
                });
                res.data.list[0].menus.forEach((item,index)=>{
                  item.index = index+2
                })
              }

              res.data.list[0].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[0].stage;
                switch (item.type) {
                  case '开标准备':
                    item.isLeaf = true;
                    item.icon = 'raw';
                    break;
                  case '公布投标人名单':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '投标文件解密':
                    item.isLeaf = true;
                    item.icon = 'file';
                    break;
                  case '唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '随机抽球法-投标单位入围':
                    item.isLeaf = true;
                    item.icon = 'openbidderEnter';
                    break;
                  case '随机抽球法-随机赋码':
                    item.isLeaf = true;
                    item.icon = 'bidderRandomCode';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '特征码一览表':
                    item.isLeaf = true;
                    item.icon = 'signatureList';
                    break;
                  case '入围名单':
                    item.isLeaf = true;
                    item.icon = 'finalists';
                    break;
                  case '抽取参数':
                    item.isLeaf = true;
                    item.icon = 'extract';
                    break;
                  case '计算结果':
                    item.isLeaf = true;
                    item.icon = 'result';
                    break;
                  case '抽取中标候选人':
                    item.isLeaf = true;
                    item.icon = 'extractBidder';
                    break;
                  case '开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '替补中标候选人':
                    item.isLeaf = true;
                    item.icon = 'alternate';
                    break;
                  case '评审结果':
                    item.isLeaf = true;
                    item.icon = 'evalResult';
                    break;
                }
              });
              commit(
                types.GET_MENU_STATUS,
                Array.isArray(res.data.list[0].menus)
                  ? res.data.list[0].menus
                  : []
              );
              // 单阶段组装导航数据
              res.data.list[0].menus.forEach(function (item, index) {
                // 添加省略符
                if (item.menuName.split('').length > 5) {
                  item.name = item.menuName.split('').slice(0, 5);
                  item.name.splice(5, null, ' ...');
                } else {
                  item.name = item.menuName.split('');
                }
              });
              window.sessionStorage.setItem('allMenu', JSON.stringify(res.data.list[0].menus));
              res.data.list[0].menus = res.data.list[0].menus.filter(
                (item, index) => index < 5
              );
              window.sessionStorage.setItem(
                'menuTrue',
                JSON.stringify(res.data.list[0].menus)
              );
              window.sessionStorage.setItem(
                'currentMenuTrue',
                JSON.stringify(res.data.list[0].menus[0])
              );
            } else {
              res.data.list[0].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[0].stage;
                switch (item.type) {
                  case '开标准备':
                    item.isLeaf = true;
                    item.icon = 'raw';
                    break;
                  case '公布投标人名单':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '投标文件解密':
                    item.isLeaf = true;
                    item.icon = 'file';
                    break;
                  case '唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '特征码一览表':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '入围名单':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                  case '开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                }
              });
              res.data.list[1].menus.forEach(function (item) {
                item.path = item.url; //复制url
                item.stage = res.data.list[1].stage;
                switch (item.type) {
                  case '公布第一信封评审结果':
                    item.isLeaf = true;
                    item.icon = 'pre';
                    break;
                  case '二信封唱标':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '系数抽取':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '评标基准价':
                    item.isLeaf = true;
                    item.icon = 'read';
                    break;
                  case '二信封开标结束':
                    item.isLeaf = true;
                    item.icon = 'finish';
                    break;
                }
              });
              let result = [];
              for (let data of res.data.list[0].menus.concat(
                res.data.list[1].menus
              )) {
                result.push(data);
              }
              commit(
                types.GET_MENU_STATUS,
                Array.isArray(result) ? result : []
              );
              // 多阶段组装导航数据
              result.forEach(function (item, index) {
                // 添加省略符
                if (item.menuName.split('').length > 5) {
                  item.name = item.menuName.split('').slice(0, 5);
                  item.name.splice(5, null, ' ...');
                } else {
                  item.name = item.menuName.split('');
                }
              });
              window.sessionStorage.setItem('allMenu', JSON.stringify(result));
              result = result.filter((item, index) => index < 5);
              window.sessionStorage.setItem('menuTrue', JSON.stringify(result));
              window.sessionStorage.setItem(
                'currentMenuTrue',
                JSON.stringify(result[0])
              );
            }
          }
        } else {
          Message.error({
            message: res.data.msg,
            iconClass: 'el-icon-circle-cross1',
          });
        }
        if (obj.data) {
          router.push({ path: obj.data });
        } else {
          if (window.sessionStorage.getItem('roleKey') == '1') {
            router.push({ path: '/index/bidOpen' });
          } else {
            router.push({ path: '/index/pubBidder' });
          }
        }
      });
  },
  handleNegotiation({ state }) {
    service
      .get('/prepare/getBidderId/' + state.currentBidSection.bidSectionId, {
        params: { bidSectionId: state.currentBidSection.bidSectionId },
      })
      .then((res) => {
        if (res.code === 200) {
          service
            .post('/bidsection/getBidSectionBriefList', {
              id: state.currentBidSectionList[0].domainId,
              bidSectionIds: state.currentBidSectionList.map(
                (item) => item.bidSectionId
              ),
            })
            .then((r) => {
              if (r.code === 200) {
                const params = state.currentBidSectionList;
                params[0]['bidderId'] = res.data.split('_')[0];
                params[0]['bidderName'] = res.data.split('_')[1];
                params[0]['openbidId'] =
                  r.data.list[0].openBidList[0].openBidId || '';
                sessionStorage.setItem('row', JSON.stringify(params));
                router.push({ path: '/bidder/consult' });
              }
            });
        } else {
          Message.error({
            message: res.data.msg,
            iconClass: 'el-icon-circle-cross1',
          });
        }
      });
  },
};
const mutations = {
  USERINFO(state, payload) {
    state.userInfo = payload;
  },
  CURRENTDATETIME(state, payload) {
    state.currentServerDateTime = payload;
  },
  PROJECTLIST(state, payload) {
    state.projectList = payload;
  },
  ACTIVENAMES(state, payload) {
    state.activeNames = payload;
  },
  CURRENTBIDSECTION(state, payload) {
    state.currentBidSection = payload;
  },
  CURRENTBIDSECTIONLIST(state, payload) {
    state.currentBidSectionList = payload;
  },
  ONLINEUSERCOUNT(state, payload) {
    state.onlineUserCount = payload;
  },
  [types.GET_MENU_STATUS](state, obj) {
    state.obj = obj;
    window.sessionStorage.setItem('allMenu', JSON.stringify(this.menu));
  },
  GETROLESTATUS(state, obj) {
    state.role = obj;
  },
};

export default {
  namespaced: true,
  modules: {
    toolbar,
  },
  state,
  getters,
  actions,
  mutations,
};
